<template>
  <div class="template-navbar">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-input
        v-model="searchKeyword"
        placeholder="搜索模块"
        class="search-input"
        prefix-icon="el-icon-search"
        @input="handleSearch"
      >
      </el-input>
      <el-button
        type="primary"
        size="mini"
        class="buttonSearch"
        @click="handleQuery"
        >搜索</el-button
      >
    </div>
    <div class="category-tabs">
      <CustomNavbar
        :items="navbarListLeft"
        direction="horizontal"
        :horizontalWidth="'65%'"
        @handleItemClick="navbarClickLeft"
        :activeIndex="activeIndex"
        :lineBottom="'8px'"
      />
    </div>
    <!-- 分类标签 -->
  </div>
</template>
<script>
export default {
  name: "MyNavbar",
  data() {
    return {
      activeIndex: 0,
      rightcom: "",
      navbarListLeft: [
        {
          label: "我的模版",
          value: "TemplateNavbar",
        },
        {
          label: "我的样式",
          value: "StyleNavbar",
        },
        {
          label: "我的收藏",
          value: "AiNavbar",
        },
      ],
      searchKeyword: "",
      hoverIndex: -1, // 悬浮状态索引
      activeCategory: 0,
      categories: [
        {
          value: 0,
          label: "我的模版",
        },
        {
          value: 1,
          label: "我的样式",
        },
        {
          value: 2,
          label: "我的收藏",
        },
      ],
      contentItems: [],
    };
  },
  created() {
    // this.industry();
  },
  methods: {
    // async industry() {
    //   this.categories = [
    //     { industryId: "all", industryName: "全部" },
    //     ...this.categories,
    //   ];

    //   console.log("leftTweet子组件获取行业分类数据----", this.categories);
    // },
    navbarClickLeft(obj) {
      this.activeIndex = obj.index;
      //   this.rightcom = obj.item.value;
      //   this.$emit("changeTab", obj);
      console.log("打印左侧顶部导航栏", obj, this.rightcom);
    },
    handleSearch() {
      this.$emit("search", this.searchKeyword);
    },
    handleQuery() {
      this.$emit("query", this.searchKeyword);
    },
    oncategory(item) {
      console.log("分类点击", item);
      this.activeCategory = item.industryId;
      this.$emit("changeTab", item);

      return;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
.template-navbar {
  border: 2px solid red;
  /* 搜索栏样式 */
  .search-bar {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
  }

  .search-input {
    ::v-deep .el-input__inner {
      height: 30px !important;
      line-height: 30px;
    }
    ::v-deep .el-input__icon {
      line-height: 30px;
    }
  }

  .buttonSearch {
    background-color: #348cf8;
    height: 29px;
    border-radius: 6px;
    margin-left: 5px;
    border-color: #348cf8;
  }

  /* 分类标签样式 */
  .category-tabs {
    margin-bottom: 24px;
    font-size: 14px;
    display: flex;
    gap: 0 37px;
    flex-wrap: wrap;
    justify-content: flex-start;

    .categoryactive {
      background-color: #edf0fc;
      color: #4c6ee2;
    }
  }
}
</style>
